<!--
If there is more than 1 panel display the panels in a soho-tabs.component
-->
<!--
[alternate]="true" - to get alternate styling
[headerTabs]="true" - to get header styling margins
-->
@if (initialBuildComplete) {
  @if (hasPanels && useSohoTabsComponent) {
    <!--    using beforeActivated as the event trigger so we build the panel before it is shown. Previously we didn't,
    and messed up the height of the page causing scrolling issues. This is to fix https://jira.lawson.com/browse/LMCLIENT-27858 -->
    <div soho-tabs #sohoTabsComponent
      class="detail-tabs"
      [disableAutoUpdatedCall]="true"
      [alternate]="isCardListDetailSections"
      [headerTabs]="isCardListDetailSections"
      [attributes]="detailSectionAttributes"
      attr.data-automation-id="lm-{{this.detailSectionAutomationIdPrefix}}-tabs"
      (beforeActivated)="onTabActivated($event)"
      >
      <div soho-tab-list-container>
        <ul soho-tab-list>
          @for (panel of detailSectionPanels; track trackById(i, panel); let i = $index) {
            <li soho-tab
              [selected]="!!panel.selected"
              [hidden]="panel.hidden"
              [disabled]="!panel.isValid">
              <a soho-tab-title
                attr.id="{{!testVersion1 ? panel.id + tabIdSuffix : null}}"
                attr.data-automation-id="lm-{{panel.automationId}}-tab"
                tabId="{{panel.id}}"
                attr.data-index="{{i}}"
              >{{panel.title}}</a>
            </li>
          }
        </ul>
      </div>
    </div>
    <div soho-tab-panel-container
      soho-busyindicator
      [text]="' '"
      [blockUI]="true"
      [displayDelay]="20"
      [timeToComplete]="this.uiLoadingIndicatorTimeout"
      [transparentOverlay]="true"
      >
      @for (panel of detailSectionPanels; track panel) {
        <div soho-tab-panel
          tabId="{{panel.id}}"
          attr.data-automation-id="lm-{{panel.automationId}}-panel"
          [ngClass]="{'lm-has-detail-sections': panel?.listSpec?.busListSpec?.detailSections, 'scrollable': !panel.hasNestedCardViewDetailSections && !hasContextCardView}"
          >
          @switch (panel.type) {
            <!--<ng-container *ngTemplateOutlet="switchTemplate"></ng-container>-->
            @case ('list') {
              <lm-detail-section-list #detailListComponent
                [panel]="panel"
                [fromDataView]="!panel.hidden ? fromDataView : null"
                [activated]="panel.activated"
                [needsReload]="panel.needsReload"
                [overlayContent]="overlayContent"
                (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
                (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                (contentModified)="onContentModified($event)"
                (panelDataUpdated)="onPanelDataUpdated($event)"
                (drillAroundEvent)="onDrillAroundEvent($event)"
                (cubeDetailSectionPVPeriodEvent)="onCubeDetailSectionPVPeriodEvent($event)"
              ></lm-detail-section-list>
            }
            @case ('multilist') {
              <lm-detail-section-multilist #detailListComponent
                [panel]="panel"
                [fromDataView]="!panel.hidden ? fromDataView : null"
                [activated]="panel.activated"
                [needsReload]="panel.needsReload"
                [overlayContent]="overlayContent"
                (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
                (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                (contentModified)="onContentModified($event)"
                (panelDataUpdated)="onPanelDataUpdated($event)"
                (drillAroundEvent)="onDrillAroundEvent($event)"
              ></lm-detail-section-multilist>
            }
            @case ('cardview') {
              <lm-detail-section-card #detailListComponent
                [panel]="panel"
                [fromDataView]="fromDataView"
                [activated]="panel.activated"
                [needsReload]="panel.needsReload"
                (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
              ></lm-detail-section-card>
            }
            @case ('standardform') {
              <lm-detail-section-form #detailListComponent
                [formSpec]="panel.formSpec"
                [fromDataView]="fromDataView"
                [activated]="panel.activated"
                [needsReload]="panel.needsReload"
                [isArchiveData]="panel.isArchiveData"
                [overlayContent]="overlayContent"
                (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
                (panelDataUpdated)="onPanelDataUpdated($event)"
                (drillAroundEvent)="onDrillAroundEvent($event)"
              ></lm-detail-section-form>
            }
            @case ('dashboard') {
              <lm-detail-section-dashboard #detailListComponent
                [panels]="panel.dashBoardPanes"
                [useTwelveColumnGrid]="panel.useTwelveColumnGrid"
                [fromDataView]="resolvedFromDataView"
                [columns]="panel.dashboardColumns"
                [activated]="panel.activated"
                [needsReload]="panel.needsReload"
                [updateVisibilityTimestamp]="updateVisibilityTimestamp"
                [isFlyoutContent]="overlayContent"
                (uiLinkEvent)="onUILinkEvent($event)"
                (dashboardContentDisplayed)="onDashboardContentDisplayed($event)"
                (sendContextMessageEvent)="onSendContextMessageEvent($event)"
                (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
                (panelTransactionEvent)="onPanelDataUpdated($event)"
                (drillAroundEvent)="onDrillAroundEvent($event)"
              ></lm-detail-section-dashboard>
            }
            @case ('link') {
              <lm-detail-section-url #detailListComponent
                [panel]="panel"
                [fromDataView]="fromDataView"
                [activated]="panel.activated"
                [needsReload]="panel.needsReload"
                (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
                (panelDataUpdated)="onPanelDataUpdated($event)"
              ></lm-detail-section-url>
            }
            @default {
              <lm-detail-section-notfound #detailListComponent
                [activated]="panel.activated"
                (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
              ></lm-detail-section-notfound>
            }
          }
        </div>
      }
    </div>
  }
  <!--
  If there is only 1 panel then no need for the soho-tabs
  TODO: have to duplicate this code since ngSwitch is being used. Can't seem to use ng-template for
  this since the template throws an error at compile time about no NGSwitch provider being defined.
  -->
  @if (hasPanels && !useSohoTabsComponent) {
    @for (panel of visiblePanels; track panel) {
      <div [ngStyle]="{'height': '100%'}" class="scrollable">
        @switch (panel.type) {
          @case ('list') {
            <lm-detail-section-list #detailListComponent
              [panel]="panel"
              [fromDataView]="fromDataView"
              [activated]="true"
              [ngStyle]="{'height': '100%'}"
              [overlayContent]="overlayContent"
              (sendContextMessageEvent)="onSendContextMessageEvent($event)"
              (contentModified)="onContentModified($event)"
              (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
              (panelDataUpdated)="onPanelDataUpdated($event)"
              (cubeDetailSectionPVPeriodEvent)="onCubeDetailSectionPVPeriodEvent($event)"
            ></lm-detail-section-list>
          }
          @case ('multilist') {
            <lm-detail-section-multilist #detailListComponent
              [panel]="panel"
              [fromDataView]="fromDataView"
              [activated]="true"
              [overlayContent]="overlayContent"
              (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
              (sendContextMessageEvent)="onSendContextMessageEvent($event)"
              (contentModified)="onContentModified($event)"
              (panelDataUpdated)="onPanelDataUpdated($event)"
            ></lm-detail-section-multilist>
          }
          @case ('cardview') {
            <lm-detail-section-card #detailListComponent
              [panel]="panel"
              [fromDataView]="fromDataView"
              [activated]="true"
              [needsReload]="panel.needsReload"
              (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
            ></lm-detail-section-card>
          }
          @case ('standardform') {
            <lm-detail-section-form #detailListComponent
              [formSpec]="panel.formSpec"
              [fromDataView]="fromDataView"
              [activated]="true"
              [isArchiveData]="panel.isArchiveData"
              [ngStyle]="{'height': '100%'}"
              [overlayContent]="overlayContent"
              (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
              (panelDataUpdated)="onPanelDataUpdated($event)"
            ></lm-detail-section-form>
          }
          @case ('dashboard') {
            <lm-detail-section-dashboard #detailListComponent
              [panels]="panel.dashBoardPanes"
              [fromDataView]="resolvedFromDataView"
              [useTwelveColumnGrid]="panel.useTwelveColumnGrid"
              [columns]="panel.dashboardColumns"
              [updateVisibilityTimestamp]="updateVisibilityTimestamp"
              [activated]="true"
              [ngStyle]="{'height': '100%'}"
              [isFlyoutContent]="overlayContent"
              (uiLinkEvent)="onUILinkEvent($event)"
              (dashboardContentDisplayed)="onDashboardContentDisplayed($event)"
              (sendContextMessageEvent)="onSendContextMessageEvent($event)"
              (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
            ></lm-detail-section-dashboard>
          }
          @case ('link') {
            <lm-detail-section-url #detailListComponent
              [panel]="panel"
              [fromDataView]="fromDataView"
              [activated]="true"
              [needsReload]="panel.needsReload"
              (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
            ></lm-detail-section-url>
          }
          @default {
            <lm-detail-section-notfound #detailListComponent
              [activated]="true"
              (detailSectionDisplayed)="onDetailSectionDisplayed($event)"
            ></lm-detail-section-notfound>
          }
        }
      </div>
    }
  }
}
